import React, { useState } from "react";
import pollsCss from "../../../assets/styles/polls/polls.module.scss";
import { generateHtml } from "../constants/generateHtml";
import { Icon, Label } from "semantic-ui-react";
import { EmailRow, NewTabIcon, Printer } from "../../iconComponents";

const PreviewPoll = ({ draft }) => {
  const timerCode = generateHtml(
    draft,
    draft?.template_data?.customization.general?.alignment
  );

  return (
    <div className={pollsCss.previewHeight}>
      <div className={pollsCss.previewPolls}>
        <div className={pollsCss.emailSubject}>
          <div className={pollsCss.emailRow}>
            <h2>Email Subject</h2>
            <EmailRow />
            <Label>
              Inbox <Icon name="close" />
            </Label>
          </div>
          <div style={{ display: "flex", gap: "15px" }}>
            <Printer />
            <NewTabIcon />
          </div>
        </div>
        <div className={pollsCss.emailHeader}>
          <div className={pollsCss.headerRow}>
            <span className={pollsCss.senderName}>Michelle Rivera</span>
            <span className={pollsCss.emailAddress}>
              {"<michelle.rivera@example.com>"}
            </span>
            <span className={pollsCss.unsubscribe}>Unsubscribe</span>
          </div>
          <div className={pollsCss.recipientInfo}>
            <span>
              to me, Sidney, Sharon
              <Icon name="caret down" />
            </span>
            <div style={{ display: "flex", gap: "10px" }}>
              <span className={pollsCss.timestamp}>9:14 AM (8 hours ago)</span>
              <span>
                <Icon name="star outline" />
              </span>
              <span>
                <Icon name="reply" />
              </span>
              <span>
                <Icon name="ellipsis vertical" />
              </span>
            </div>
          </div>
        </div>
        <div className={pollsCss.mainContent}>
          <p>
            Lorem ipsum dolor sit amet, consectetur adipiscing elit. Copy this
            link and paste it into your email, and it will appear as a poll to
            recipients. Vivamus luctus urna sed urna ultricies ac tempor dui
            sagittis.
          </p>
        </div>
        <div
          className={pollsCss.previewHtml}
          dangerouslySetInnerHTML={{ __html: timerCode }}
        />

        <div className={pollsCss.answerBtn}>
          <button>Looking forward to it!</button>
          <button>We will be there!</button>
          <button>Thanks for the update!</button>
        </div>
        <hr />
        <div className={pollsCss.replyBtn}>
          <button>
            <span>
              <Icon name="reply" />
            </span>
            Reply
          </button>
          <button>
            <span>
              <Icon name="reply all" />
            </span>
            Reply all
          </button>
          <button>
            <span>
              <Icon name="long arrow alternate right" />
            </span>
            Forward
          </button>
        </div>
      </div>
    </div>
  );
};

export default PreviewPoll;
